import { useAlert } from 'react-alert';
import { useNavigate } from 'react-router';
import { useEffect, useState } from 'react';
import useAuthz from '../../hooks/useAuthz';
import { ClipLoader } from 'react-spinners';
import AgGrid from '../../components/AgGrid/AgGrid';
import { Paper } from '@mui/material';
import TopBar from '../../components/Layout/TopBar';
import axios from 'axios';
import { URL_API } from '../../utils/globalConfig';
import MyButton from '../../components/Layout/MyButton';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import ActionsBilledThirdPartiesRenderer from '../../components/AgGrid/ActionsBilledThirdPartiesRenderer';

const BilledThirdPartiesView = (props) => {
  const alert = useAlert();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [authz, user, profil] = useAuthz();
  const [billedThirdParties, setBilledThirdParties] = useState([]);

  const columnDefs = [
    {
      headerName: 'Raison sociale',
      field: 'raison_sociale',
      flex: 1,
      minWidth: 200,
      sortable: true,
      filter: 'agTextColumnFilter',
    },{
      headerName: 'N° TVA',
      field: 'num_tva',
      flex: 1,
      minWidth: 200,
      sortable: true,
      filter: 'agTextColumnFilter',
    },{
      headerName: 'N° SAP',
      field: 'num_sap',
      flex: 1,
      minWidth: 200,
      sortable: true,
      filter: 'agTextColumnFilter',
    },{
      headerName: 'N° SAP Filiale',
      field: 'num_sap_subsidiary',
      flex: 1,
      minWidth: 200,
      sortable: true,
      filter: 'agTextColumnFilter',
    },{
      headerName: 'N° SIRET/SIREN',
      field: 'num_siren',
      flex: 1,
      minWidth: 200,
      sortable: true,
      filter: 'agTextColumnFilter',
    },{
      headerName: 'Mails comptabilité',
      field: 'email',
      flex: 1,
      minWidth: 200,
      sortable: true,
      filter: 'agTextColumnFilter',
    },{
      headerName: 'N° Telephone 1',
      field: 'telephone1',
      flex: 1,
      minWidth: 200,
      sortable: true,
      filter: 'agTextColumnFilter',
    },{
      headerName: 'N° Telephone 2',
      field: 'telephone2',
      flex: 1,
      minWidth: 200,
      sortable: true,
      filter: 'agTextColumnFilter',
    },
    // TODO: ajouter bouton édition ( et prévoir la suppression ?)
    {
      headerName: 'actions',
      field: '',
      sortable: false,
      cellRenderer: 'actionsBilledThirdPartiesRenderer',
      pinned: 'right',
      cellStyle: { 'justify-content': 'flex-start' },
      width: 100,
    },
  ];
  const agGridOptions = {
    suppressCellSelection: true, suppressHorizontalScroll: false, animateRows: true, rowClassRules: {
      'user-desactivate': function(params) {
        return params.data.deleted === true;
      },
    },
  };
  const frameworkComponents = {
    actionsBilledThirdPartiesRenderer: ActionsBilledThirdPartiesRenderer
  };

  // region useEffect
  useEffect(() => {
    if (profil.profil === 6) {
      alert.error('Vous n\'êtes pas autorisé à accéder aux tiers facturés');
      navigate('/');
    }

    apiListBilledThirdParties();
    document.title = 'TE - Gestion des tiers facturés';
  }, []);
  // endregion

  // region functions
  // endregion

  // region API
  const apiListBilledThirdParties = () => {
    axios({ method: 'get', url: `${URL_API}/billed-third-party/full-list` })
      .then((response) => {
        setBilledThirdParties(response.data);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        alert.removeAll();
        alert.error(error.response.data.message);
      });
  }
  //endregion

  return (<div style={{ height: '100%' }}>
    <TopBar title='Gestion des tiers facturés' className='topbar-contenu' color={props.params.color}
            filterContainer={<></>}
            buttons={
              <div className='topbar-buttons'>
                <MyButton onClick={() => navigate('/panneau-administration/tiers-factures/creation')}
                          icon={faPlus} label={'Créer un tiers facturés'} />
                <MyButton onClick={() => navigate('/panneau-administration')} icon={''} label={'Retour'} />
              </div>
            }
    />

    <div className='row' style={{ margin: 0, overflow: 'hidden' }}>
      <ClipLoader color='#0094ca' loading={isLoading} size={75}
                  css={'display: flex; margin: 25px;justify-content: center;'} />

      {!isLoading &&
        (<Paper style={{ height: '100%', width: '100%', borderTop: '1px solid #4db4da' }}>
          <AgGrid
            key={'ag-grid-billed-third-party'}
            rowData={billedThirdParties}
            columnDefs={columnDefs}
            rowHeight={40}
            pagination={false}
            frameworkComponents={frameworkComponents}
            gridOptions={agGridOptions}
            sortable={false}
          />
        </Paper>)
      }
    </div>
  </div>);
};

export default BilledThirdPartiesView;